import { z } from 'zod';

import {
	SortNameV1,
	SortOrderTypeV1x2,
} from '../../../../api/generated/cz.partners.pid.backofficegateway.pididentityverification';

export const identityVerificationSortSchema = z
	.object({
		name: z.enum([SortNameV1.CREATED_AT, SortNameV1.UPDATED_AT]),
		order: z.enum([SortOrderTypeV1x2.ASC, SortOrderTypeV1x2.DESC]),
	})
	.catch({
		name: SortNameV1.CREATED_AT,
		order: SortOrderTypeV1x2.DESC,
	});
